import { FC, useState } from 'react';
import Layout from '../../common/Layout';
import { ReturnParserOutputData } from '../../../../middlewares/Return/returnTypes';
import PaymentInformation from '../Payment/PaymentInformation';
import PaymentStatus from '../Payment/PaymentStatus';
import useIsTemplate from '../../../../hooks/useIsTemplate';
import ColorPickerIcon from '../../../shared/ColorPickerIcon';
import ChangeColorModal from '../../common/ChangeColorModal';
import useColors from '../../../../hooks/useColors';
import SubscriptionInformation from '../Subscription/SubscriptionInformation';
import SubscriptionStatus from '../Subscription/SubscriptionStatus';

// icon
import { ReactComponent as CheckCircleIcon } from '../../../../assets/feather/check-circle.svg';
import { ReactComponent as XCircleIcon } from '../../../../assets/feather/x-circle.svg';

interface ReturnBaseTemplateOneProps {
  apiData: ReturnParserOutputData;
}

const ReturnBaseTemplateOne: FC<ReturnBaseTemplateOneProps> = (props) => {
  const { apiData } = props;
  const { primaryColor } = useColors();
  const { isTemplate } = useIsTemplate();
  const [showColorModal, setShowColorModal] = useState<boolean>(false);

  const paymentTitle = (isSubscription: boolean, status: string) => {
    if (isSubscription)
      return (
        <h1 className="w-full text-3xl font-medium my-auto">
          Información de la Suscripción
        </h1>
      );
    if (status.includes('exitosa')) {
      return (
        <div className="flex flex-col justify-between mx-auto md:flex-row">
          <CheckCircleIcon className="h-8 mt-auto mb-0 text-green-500 mx-auto md:my-auto md:mr-2" />
          <h1 className="w-full text-3xl font-medium mt-2 mb-auto md:my-auto">
            Transacción Exitosa
          </h1>
        </div>
      );
    }
    return (
      <div className="flex flex-col justify-between mx-auto md:flex-row">
        <XCircleIcon className="h-8 mt-auto mb-0 text-red-500 mx-auto md:my-auto md:mr-2" />
        <h1 className="w-full text-3xl font-medium mt-2 mb-auto md:my-auto">
          Hubo un error en tu transacción
        </h1>
      </div>
    );
  };

  return (
    <>
      <Layout shape="smaller">
        <div className="w-full">
          <div className="h-[30%] w-full flex border-b-2 border-amber-300">
            {paymentTitle(
              apiData.isSubscription,
              apiData.payment.statusMessage
            )}
          </div>
          {!apiData.isSubscription && (
            <div className="h-[60%] w-full flex justify-center flex-col md:flex-row">
              <PaymentInformation
                transactionRequest={apiData.transactionRequest}
                merchant={apiData.merchant}
              />
              <PaymentStatus
                payment={apiData.payment}
                transactionRequest={apiData.transactionRequest}
              />
            </div>
          )}
          {apiData.isSubscription && (
            <div className="h-[60%] w-full flex justify-center flex-col md:flex-row">
              <SubscriptionInformation
                transactionRequest={apiData.transactionRequest}
                merchant={apiData.merchant}
              />
              <SubscriptionStatus subscription={apiData.subscription} />
            </div>
          )}
          {apiData.merchant.host && (
            <div className="mb-2">
              <p className="center black-text" style={{ textAlign: 'center' }}>
                Para volver al sitio de {apiData.merchant.name}, sigue este{' '}
                <a
                  href={apiData.merchant.host}
                  className="border-b-2"
                  style={{ color: primaryColor, borderColor: primaryColor }}
                >
                  link
                </a>
                .
              </p>
            </div>
          )}
        </div>
      </Layout>
      {isTemplate && <ColorPickerIcon openModal={setShowColorModal} />}
      {isTemplate && showColorModal && (
        <ChangeColorModal closeModal={setShowColorModal} />
      )}
    </>
  );
};

export default ReturnBaseTemplateOne;
